<!----------------------- Компонент неправильної сторінки --------------------->
<template>
  <div>
    <!-- Cтраница редиректа, если кто то вдруг что то левое в адресной строке забъет -->
  </div>
</template>

<script>
import Cookies from "js-cookie"; // Модуль для роботи з кукі

export default {
  created() {
    if (Cookies.get('token')) {
      document.location.href = 'https://auth.skyservice.online/';
      this.$router.push('/');
    } else {
      document.location.href = 'https://auth.skyservice.online/';
      // this.$router.push('/');
    }
  }
}
</script>
